<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_toc_1">“Beyond the mind is the ‘nature of the mind,’ beyond all limits.... How can we approach an understanding of it?”</p>
<p class="P_Normal">—Namkhai Norbu, <span style=" font-style: italic; font-size: 1.00em;">Dzogchen: The Self-Perfected State</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?2a3378c2